export function HomePage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-4xl font-bold tracking-tight">
          Welcome to Writing Agent
        </h1>
        <p className="mt-2 text-lg text-muted-foreground">
          Your AI-powered writing assistant for creating professional documents.
        </p>
      </div>

      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        <div className="rounded-lg border bg-card p-6 text-card-foreground shadow-sm">
          <h3 className="text-lg font-semibold">Official Documents</h3>
          <p className="mt-2 text-sm text-muted-foreground">
            Generate professional official documents with AI assistance.
          </p>
        </div>

        <div className="rounded-lg border bg-card p-6 text-card-foreground shadow-sm">
          <h3 className="text-lg font-semibold">Multi-Agent System</h3>
          <p className="mt-2 text-sm text-muted-foreground">
            Powered by LangGraph for intelligent document generation.
          </p>
        </div>

        <div className="rounded-lg border bg-card p-6 text-card-foreground shadow-sm">
          <h3 className="text-lg font-semibold">Session Management</h3>
          <p className="mt-2 text-sm text-muted-foreground">
            Keep track of all your writing sessions in one place.
          </p>
        </div>
      </div>
    </div>
  );
}
